import utils from 'utils'
import buildTask from './view/buildTask.html'
import buildTaskModalCtr from './buildTaskModalCtr'
class taxDeclarationConfig {
    constructor($scope, httpRequest, $state, $stateParams, sweetalert, logger, initSortService, $timeout, authService, Upload, $uibModal) {
        $scope.exportCollapsed = false
        $scope.importBtnCollapsed = false
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                taxNo: '',
                companyName: '',
                taxplayerType: '',
                regionName: '',
                departmentNo: '',
                cityName: '',
                taxBelong: '',
            },
        }
        // 重置
        $scope.reset = function () {
            $scope.queryParam.param = {
                taxNo: '',
                companyName: '',
                taxplayerType: '',
                regionName: '',
                departmentNo: '',
                cityName: '',
                taxBelong: '',
            }
        }
        // 选中的购方信息
        $scope.selectedRows = []
        $scope.reset()
        // 表头排序
        $scope.orderMap = initSortService('buyerParam')
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('buyerParam', JSON.stringify($scope.queryParam))
            $scope.queryParamInfo()
        }
        // 获取所有申报期
        httpRequest.get_queryByIdAndStatus(0).then((res) => {
            // 过滤掉按年申报
            $scope.allApplyPeriod = res.data.value.filter((item) => {
                return item.reportingPeriod !== '3'
            })
        })
        //自动查询展示
        const queryParamInfo = function queryParamInfo() {
            httpRequest.post_getSbConfigList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                $scope.queryParam.pageSize = res.data.value.pageSize
                $scope.selectedRows = []
            })
        }
        // 搜索
        $scope.searchList = function () {
            queryParamInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            queryParamInfo()
        }
        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["department_no", "taxplayer_type","zzs_sign","zzs_declareType","accounting_standard","submission_status"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
        })
        // 主管税局省（市）
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 获取管理城市时两个都要传
        $scope.$watch('queryParam.param.regionName', function (newVal, oldVal) {
            //重置
            if ($scope.queryParam.param.regionName == '') {
                $scope.belleRegionCityList = []
                return
            }
            angular.forEach($scope.dictData.department_no, function (item, index) {
                if (item.enumName === $scope.queryParam.param.departmentNo) {
                    $scope.departmentNo = item.enumCode
                }
            })
            angular.forEach($scope.belleRegionList, function (item, index) {
                if (item.regionName === newVal) {
                    $scope.regionNo = item.treeLevelCode
                }
            })
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        })
        queryParamInfo()
        $scope.queryParamInfo = queryParamInfo
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量删除',
                    hasPermit: 'tax_declaration_delete',
                    handler() {
                        $scope.batchDeletion()
                    },
                },
                {
                    text: '生成任务',
                    hasPermit: 'tax_declaration_task',
                    handler() {
                        $scope.buildTask()
                    },
                },
            ],
        }
        $scope.tableDropdownConfig = [
            {
                label: '编辑',
                handler(item) {
                    $state.go('system.settingcenter.taxDeclarationConfig.edit', {
                        id: item.taxId,
                    })
                },
                showWhile(item, hasPermit) {
                    // return hasPermit('declareParam_edit')
                    return true
                },
            },
        ]
        // 导入
        $scope.uploadFiles = function uploadFiles(file, errFiles) {
            if (file == null && errFiles.length >= 1) {
                logger.logError('文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入')
                return
            }
            if (file) {
                file.upload = Upload.upload({
                    url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importBill`,
                    data: {
                        importFile: file,
                        code: 'SB_VAT_IMPORT',
                    },
                })
                // 文件上传
                // loading动画
                const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                })
                file.upload.then(
                    (res) => {
                        $timeout(() => {
                            if (!res.data.success) {
                                layer.close(importinglayer)
                                return logger.logError(res.data.message || '上传失败')
                            }
                            if (res.data.value.sourceCount === 0) {
                                layer.close(importinglayer)
                                return logger.logTips('导入数据为空！', 'warn')
                            }
                            const { batchNo, sourceCount, errorCount } = res.data.value
                            // 结果弹框
                            // if (res.data.value.errorCount > 0) {
                            httpRequest
                                .post_getPageDlBatchInfoList({
                                    pageNum: 1,
                                    pageSize: 10,
                                    param: res.data.value.batchNo,
                                })
                                .then((res1) => {
                                    layer.close(importinglayer)
                                    $scope.importResultModal({
                                        batchNo,
                                        sourceCount,
                                        successCount: sourceCount - errorCount,
                                        errorCount,
                                        data: res1.data.value,
                                    })
                                    queryParamInfo()
                                })
                        })
                    },
                    (response) => {}
                )
            }
        }
        // 导入结果弹窗
        $scope.importResultModal = function (modalData) {
            const modalInstance = $uibModal.open({
                templateUrl: 'importResult.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'logger',
                    'items1',
                    function ($scope, $uibModalInstance, logger, items1) {
                        $scope.modalData = items1
                        $scope.list = items1.data.list
                        console.log($scope.modalData)
                        $scope.pageOptions = {
                            // 分页器
                            totalItems: $scope.modalData.data.total,
                            currentPage: ++$scope.modalData.data.prePage,
                            maxSize: $scope.modalData.data.pageSize,
                        }
                        // 关闭
                        $scope.ok = () => {
                            $uibModalInstance.close()
                        }
                        // 分页查询
                        $scope.pageChanged = () => {
                            queryList()
                        }
                        function queryList() {
                            httpRequest
                                .post_getPageDlBatchInfoList({
                                    pageNum: $scope.pageOptions.currentPage,
                                    pageSize: $scope.pageOptions.maxSize,
                                    param: $scope.modalData.batchNo,
                                })
                                .then((res) => {
                                    $scope.list = res.data.value.list
                                    $scope.pageOptions = {
                                        // 分页器
                                        totalItems: res.data.value.total,
                                        currentPage: ++res.data.value.prePage,
                                        maxSize: res.data.value.pageSize,
                                    }
                                })
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal-importexcel',
                windowClass: 'mod-modal mod-modal-lg',
                bindToController: true,
                resolve: {
                    items1() {
                        return modalData
                    },
                },
            })
            modalInstance.result.then(
                () => {},
                () => {}
            )
        }
        // 模板下载
        $scope.downloadExcel = function () {
            window.open(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/exportRpaGsConfigTemple?code=SB_VAT_NOTIMPORT&accessToken=${localStorage.getItem('id_token')}`)
        }
        // 批量删除
        $scope.batchDeletion = function () {
            if (!$scope.selectedRows.length) {
                return logger.logError('请选择数据后操作')
            }
            // 可删除的集合
            let deletionRows = []
            angular.forEach($scope.selectedRows, function (item, index) {
                deletionRows.push(item.taxId)
            })
            deletionRows = deletionRows.map(String)
            httpRequest.post_batchConfigDelete(deletionRows, '批量删除成功').then((res) => {
                queryParamInfo()
            })
        }
        // 生成任务
        $scope.buildTask = function () {
            if (!$scope.selectedRows.length) {
                return logger.logError('请选择数据后操作')
            }
            const modalBuildTask = $uibModal.open({
                template: buildTask,
                controller: buildTaskModalCtr,
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                bindToController: true,
                resolve: {
                    declareType() {
                        return $scope.dictData.zzs_declareType
                    },
                    selectedRows() {
                        return $scope.selectedRows
                    },
                    allApplyPeriod() {
                        return $scope.allApplyPeriod
                    },
                },
            })
            modalBuildTask.result.then(
                () => {
                    queryParamInfo()
                },
                () => {}
            )
        }
        $scope.customizedConfig = {
            version: 1.21,
            queryConfig: [
                {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属区域',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局省（市）',
                    selected: false,
                    default: false,
                },
                {
                    label: '财务报表是否报送',
                    selected: false,
                    default: false,
                },
                {
                    label: '财务报表适用会计准则',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建人',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改人',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改时间',
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    label: '纳税人识别号',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '纳税人类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '事业部',
                    selected: true,
                    default: true,
                },
                {
                    label: '所属区域',
                    selected: true,
                    default: true,
                },
                {
                    label: '主管税局省（市）',
                    selected: true,
                    default: true,
                },
                {
                    label: '启用申报税种',
                    selected: true,
                    default: true,
                },
                {
                    label: '管理城市',
                    selected: true,
                    default: true,
                },
                {
                    label: '财务报表是否报送',
                    selected: true,
                    default: true,
                },
                {
                    label: '财务报表适用会计准则',
                    selected: true,
                    default: true,
                },
                {
                    label: '创建人',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改人',
                    selected: false,
                    default: false,
                },
                {
                    label: '最近修改时间',
                    selected: false,
                    default: false,
                },
            ],
        }
    }
}
taxDeclarationConfig.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'sweetalert', 'logger', 'initSortService', '$timeout', 'authService', 'Upload', '$uibModal']
export default taxDeclarationConfig



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/taxDeclarationConfig/taxDeclarationConfigCtrl.js